// extracted by mini-css-extract-plugin
module.exports = {"container":"SpinningDigit_container__3brn2","allDigits":"SpinningDigit_allDigits__3S2Hh","animate":"SpinningDigit_animate__IrEBI","spinit":"SpinningDigit_spinit__1pGrb"};